<style scoped>
</style>

<template>
	<div>
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>
		<v-autocomplete
			v-model="current"
			return-object
			:loading="loading"
			:items="items"
			:search-input.sync="search"
			item-value="id"
			item-text="display_name"
			cache-items
			hide-no-data
			hide-details
			:label="label"
			@change="new_value => $emit('on_change', new_value)"
		>
			<template v-slot:selection="data">
				<v-user-avatar
					v-if="show_avatar"
					:code="data.item.display_name"
					:image="'/api/addressbook/' + data.item.id + '/image.png'"
					class="mr-1"
					size="24"
				/>
				{{ data.item.display_name }}
			</template>
			<template v-slot:item="data">
				<v-user-avatar
					v-if="show_avatar"
					left
					:code="data.item.display_name"
					:image="'/api/addressbook/' + data.item.id + '/image.png'"
					class="mr-1"
					size="24"
				/>
				<v-list-item-content>
					<v-list-item-title v-html="data.item.display_name"></v-list-item-title>
				</v-list-item-content>
			</template>
		</v-autocomplete>
	</div>
</template>

<script>
export default {
	model: {
		prop: "record",
		event: "on_change"
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		record: {
			type: Object,
			default() {
				return {
					id: 0,
					display_name: ''
				}
			}
		},
		types: {
			type: String,
			default: '1,2,3,4,5,6,7,8,9,10,11,12,13,14'
		},
		show_avatar: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			errormsg: '',
			loading: false,
			iteration: 0,
			items: [],
			search: null,
			current: this.record,
		}
	},
	methods: {
		query(v) {
			let self = this;
			this.errormsg = '';

			this.loading = true;

			this.iteration += 1;
			let search_iteration = this.iteration;

			// build our url parameters
			let params = new Array();
			if (v != '') params.push("name=" + encodeURIComponent(v));
			params.push("abook_types=" + encodeURIComponent(this.types));
			// params.push("short_results=false");

			// build our url, we have to add url escaping here!
			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					if (search_iteration == self.iteration) {
						let json = d.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						if (json.status == "OK") {
							self.items = json.data;

							self.items.sort(function(a,b) {
								let vl = v.toLowerCase();
								let a_starts_with = a.display_name.substr(0,vl.length) == vl;
								let b_starts_with = b.display_name.substr(0,vl.length) == vl;
								if (a_starts_with == b_starts_with) {
									if (a.display_name.toLowerCase() < b.display_name.toLowerCase()) {
										return -1;
									} else if (a.display_name.toLowerCase() > b.display_name.toLowerCase()) {
										return 1;
									} else {
										return 0;
									}
								} else if (a_starts_with) {
									return -1;
								} else /* if (b_starts_with) */ {
									return 1;
								}
							})
						} else {
							self.errormsg = json.reason;
						}
					}
				})
				.catch(function(e) {
					if (search_iteration == self.iteration) {
						console.log(e);
						self.errormsg = e.message;
					}
				})
				.finally(function() {
					if (search_iteration == self.iteration) {
						self.loading = false;
					} else {
						// this was the result or error for a search started before the last search we did
						// we can safely ignore it. If the last search is still going loading is still true
						// if the latest search has already finished it is already being displayed and loading is already false.
					}
				});
		},		
	},
	watch: {
		'record.id'() {
			if (this.current.id != this.record.id) {
				this.current = this.record
			}
		},
		'search'(val) {
			val && val !== this.select && this.query(val)
		},

	}
}
</script>
